import React, { Component } from "react";
import { Button, Grid, Row, Col } from "react-bootstrap";
import BaseModal from "./base_modal";
import "./modal.scss";
import "../../css/delete_modal.scss";
import LoadingButton from "../forms/loading_button/loading_button";

class ShowDeleteModal extends Component {
  render() {
    return (
      <BaseModal
        title={"Delete Podcast"}
        showContent={true}
        close={this.props.closeModal}
        Content={() => {
          return (
            <Grid fluid>
              <Row>
                <Col md={10} mdOffset={1} xs={12}>
                  <div className="delete-modal-content">
                    Are you sure you want to delete this show?
                  </div>
                </Col>
              </Row>
            </Grid>
          );
        }}
        Footer={() => {
          return (
            <Grid fluid>
              <Row>
                <Col mdOffset={1} md={5} xs={6}>
                  <Button className="btn-secondary modal-button" onClick={this.props.closeModal}>
                    Cancel
                  </Button>
                </Col>
                <Col md={5} xs={6}>
                  <LoadingButton
                    className="btn btn-primary modal-button"
                    isLoading={this.props.isLoading}
                    onClick={() =>
                      this.props.deleteShow(this.props.showUUID, this.props.user).then(result => {
                        if (result.status === 200) {
                          this.props.closeModal();
                          this.props.history.push("/");
                        }
                      })
                    }>
                    Delete
                  </LoadingButton>
                </Col>
              </Row>
            </Grid>
          );
        }}
      />
    );
  }
}

export default ShowDeleteModal;
